import { Component, Input } from '@angular/core';
import { DesignBlockBaseViewComponent, WebsiteBlockAction } from '@sb/library/base';
import { WebsiteBlockEmbedDisplayItem, WebsiteBlockEmbedType } from '@sb/library/data-models';

@Component({
    selector: 'lib-video-design-block',
    templateUrl: './video-design-block.component.html',
    styleUrls: ['./video-design-block.component.scss']
})
export class VideoDesignBlockComponent extends DesignBlockBaseViewComponent {
    @Input() websiteBlockData!: WebsiteBlockEmbedDisplayItem;

    readonly WebsiteBlockEmbedType = WebsiteBlockEmbedType;

    EditClicked() {
        this.Scope.HandleBlockAction(this.websiteBlockData, WebsiteBlockAction.Edit);
    }

    get type(): WebsiteBlockEmbedType {
        return this.websiteBlockData.EmbedType;
    }

    get isFullWidth(): boolean {
        return this.websiteBlockData.IsFullWidth;
    }

    get url(): string | null {
        return this.websiteBlockData.Source;
    }
}